import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names using clsx and merges Tailwind classes using tailwind-merge
 * This utility is essential for shadcn/ui component styling
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get environment variable with fallback
 * Uses import.meta.env for Vite environment variables
 */
export function getEnvVar(key: string, defaultValue?: string): string {
  const value = import.meta.env[key]
  if (value === undefined) {
    if (defaultValue !== undefined) {
      return defaultValue
    }
    throw new Error(`Environment variable ${key} is not defined`)
  }
  return value
}

/**
 * Get environment variable as boolean
 */
export function getEnvBool(key: string, defaultValue = false): boolean {
  const value = import.meta.env[key]
  if (value === undefined) {
    return defaultValue
  }
  return value === 'true' || value === '1'
}
